import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiUrl from "../libs/baseUrl";
import { errorHandeling } from "../errorHandeling";

function useSubmitVacation() {

const token = useSelector(state => state.user.token);

const navigate = useNavigate();


const submitTheVacation = async ( exitPermissionDayField , existPermissionTime ,
    startingDateVacField , endingDateVacField , missionStartTime , missionEndTime ,  
    filesArr , reason , job_id , vacationType , setErrorResponsable , setReason ,
    setLoading , setDateError
     )=>{

if(reason?.length !== 0){

    let start_date = 0;
    let end_date  = 0 ;
  
    if(vacationType ==="EXIT_PERMISSION"){
      start_date = `${exitPermissionDayField} ${existPermissionTime}:00`;
      end_date = "";
    }
    else if(vacationType ==="MISSION"){
      start_date = `${startingDateVacField} ${missionStartTime}:00`;
      end_date = `${endingDateVacField} ${missionEndTime}:00`;
    }
    else{
      start_date = startingDateVacField;
      end_date = endingDateVacField;
    }

    const formData = new FormData();

    formData.append("job_id", job_id);
    formData.append("type", vacationType);
    formData.append("start_date", start_date);
    formData.append("end_date", end_date);
    formData.append("reasons", reason);

    for ( const image of filesArr ) {
        formData.append("files[]", image);
      }
  
    try {
      setLoading(true)
  
      const response = await axios.post(
        `${apiUrl}/vacations`,
         formData ,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setLoading(false)
  
      setErrorResponsable("")
      setDateError(null)
      setReason("")
      navigate("/emp");
      
    } catch (error) {
      console.error('Error:', error);
      setLoading(false)
      if(error.response?.data?.message === "ERR_01"){
        setDateError("*هنالك طلب اجازة سابق يتعارض مع طلب الاجازة الحالي")
      }
      else{
        setDateError(errorHandeling(error));
      }
    }
    
  }
  else{
    setDateError("*يجب أن تحدد سبب الاجازة قبل ارسال الطلب");
    setErrorResponsable("reason");
  }
  
  }
          

return { submitTheVacation };
}

export default useSubmitVacation;